<template>
    <main-content>
        <div v-if="show_gateway_tabs" class="bg-white p-3 rounded shadow-sm mb-3">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <router-link :class="['nav-link', tab == 'gateway-form' ? 'active':'']" data-toggle="tab" :to="`/settlement-settings/ipg/${gateway_hashid}/gateway-form`" role="tab" :aria-selected="tab == 'gateway-form'">
                        {{ $t('label.settlement_schedule') }}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :class="['nav-link', tab == 'changes-requests' ? 'active':'']" data-toggle="tab" :to="`/settlement-settings/ipg/${gateway_hashid}/changes-requests`" role="tab" :aria-selected="tab == 'changes-requests'">
                        {{ $t('label.add_sheba_to_gateway') }}
                    </router-link>
                </li>
                <li class="nav-item" v-if="show_enamad_tab">
                    <router-link :class="['nav-link', tab == 'register-enamad' ? 'active':'']" data-toggle="tab" :to="`/settlement-settings/ipg/${gateway_hashid}/register-enamad`" role="tab" :aria-selected="tab == 'register-enamad'">
                        {{ $t('label.enamad_register') }}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :class="['nav-link', $route.name == 'gateways_allotment' ? 'active' : '']" :to="`/gateways/${gateway_hashid}/allotment`">{{ $t('allotment.allotment_details') }}</router-link>
                </li>
                <li class="nav-item">
                    <router-link :class="['nav-link', $route.name == 'gateway_stakeholders_list' ? 'active' : '']" :to="`/gateways/stakeholders/${gateway_hashid}`">{{ $t('stakeholders.label.shop_stakeholders_list') }}</router-link>
                </li>
                <li class="nav-item">
                    <router-link :class="['nav-link', $route.name == 'stakeholders_get' && $route.query.gateway_hashid == gateway_hashid ? 'active' : '']" :to="`/stakeholders?gateway_hashid=${gateway_hashid}`">{{ $t('stakeholders.label.manage_stakeholders') }}</router-link>
                </li>
            </ul>
        </div>
        <page-title title_text="شریکان تجاری" icon="stakeholders">
            <div class="dropdown">
                <button class="btn btn-success dropdown-toggle app-dropdown-action-button" type="button" data-toggle="dropdown">
                    افزودن شریک
                </button>
                <div class="dropdown-menu">
                    <!-- <router-link to="/stakeholders/create" class="dropdown-item">{{ $t('stakeholders.btn.add_gateway_type_stakeholder') }}</router-link> -->
                    <router-link to="/stakeholders/create-from-users" class="dropdown-item">{{ $t('stakeholders.btn.add_from_users') }}</router-link>
                </div>
            </div>
        </page-title>

        <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px">
            <div class="row">

                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input  name="full_name"
                                class="form-control"
                                :placeholder="$t('label.full_name')"
                                id="full_name"
                                v-model="filter_full_name">
                    </div>
                </div>

                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input  :dir="filter_cellphone_number == '' ? 'rtl': 'ltr'"
                                class="form-control"
                                name="cellphone_number"
                                :placeholder="$t('label.phone')"
                                id="cellphone_number"
                                v-model="filter_cellphone_number">
                    </div>
                </div>

                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <select id="merchant_type"
                                name="merchant_type"
                                class="form-control kt-selectpicker"
                                v-model="filter_merchant_type">
                            <option :value="null" v-text="$t('label.merchant_type')" selected disabled></option>
                            <option :value="merchant_type.REAL" v-text="merchant_type_str.get(merchant_type.REAL)"></option>
                            <option :value="merchant_type.LEGAL" v-text="merchant_type_str.get(merchant_type.LEGAL)"></option>
                        </select>
                    </div>
                </div>

                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <select id="status"
                                name="status"
                                class="form-control kt-selectpicker"
                                v-model="filter_status">
                            <option :value="null" v-text="$t('label.status')" selected disabled></option>
                            <option :value="stakeholder_status.CREATED"  v-text="stakeholder_status_str.get(stakeholder_status.CREATED)"></option>
                            <option :value="stakeholder_status.PENDING"  v-text="stakeholder_status_str.get(stakeholder_status.PENDING)"></option>
                            <option :value="stakeholder_status.ACTIVE"   v-text="stakeholder_status_str.get(stakeholder_status.ACTIVE)"></option>
                            <option :value="stakeholder_status.REJECTED" v-text="stakeholder_status_str.get(stakeholder_status.REJECTED)"></option>
                            <option :value="stakeholder_status.BLOCKED"  v-text="stakeholder_status_str.get(stakeholder_status.BLOCKED)"></option>
                        </select>
                    </div>
                </div>

                <div class="col-sm my-2">
                    <div class="d-flex">
                        <button
                            :class="query ? 'btn btn-success' : 'btn btn-success btn-block'"
                            style="border-radius: 10px"
                            @click="get_data(stakeholders.first_page_url)"
                        >
                            اعمال فیلتر
                        </button>
                        <button
                            class="btn btn-danger mr-1"
                            style="border-radius: 10px"
                            @click="reset_and_get"
                            v-if="query"
                        >
                            حذف فیلتر
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
        <div
            class="bg-white shadow-sm py-3 my-2"
            style="border-radius: 10px"
        >
            <div class="px-3">
                <div class="table-responsive">
                    <table
                        class="table table-responsive table-borderless text-center"
                        v-if="stakeholders && stakeholders.data.length > 0"
                    >
                        <thead>
                            <tr>
                                <th scope="col" style="background-color: #eee; border-radius: 0 16px 16px 0;">شناسه</th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.full_name')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.phone')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.type')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.merchant_type')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.created_at')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.status')"></th>
                                <th scope="col" style="background-color: #eee; border-radius: 16px 0 0 16px">جزییات</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(stakeholder, index) in stakeholders.data"
                                :key="index"
                            >
                                <td class="en_num">{{ stakeholder.id }}</td>
                                <td>{{ stakeholder.full_name }}</td>
                                <td>{{ stakeholder.cellphone_number }}</td>
                                <td>
                                    <span :class="'label label-inline label-light-' + relatedMerchantTypeVariant(stakeholder.type)">
                                        {{ relatedMerchantTypeStr.get(stakeholder.type) }}
                                    </span>
                                </td>
                                <td>{{ merchant_type_str.get(stakeholder.merchant_type) }}</td>
                                <td>{{ stakeholder.created_at }}</td>
                                <td>
                                    <span :class="'label label-inline label-light-' + stakeholder_variant(stakeholder.status)">
                                        {{ stakeholder_status_str.get(stakeholder.status) }}
                                    </span>
                                </td>
                                <td>
                                    <router-link :to="getUpdateLink(stakeholder.type, stakeholder.id)">
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        width="20"
                                        fill="#bbb"
                                        >
                                        <path d="M0 0h24v24H0V0z" fill="none" />
                                        <path
                                            d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                                        />
                                        </svg>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="empty-table" style="height: 300px" v-else>
                        <table class="table table-responsive table-borderless text-center">
                        <thead>
                            <tr>
                            <th scope="col" style="background-color: #eee; border-radius: 0 16px 16px 0;">شناسه</th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.full_name')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.phone')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.type')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.merchant_type')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.created_at')"></th>
                                <th scope="col" style="background-color: #eee;" v-text="$t('label.status')"></th>
                                <th scope="col" style="background-color: #eee; border-radius: 16px 0 0 16px">جزییات</th>
                            </tr>
                        </thead>
                        </table>
                        <div class="not-found" style="margin: 0 auto">
                            <img src="@/assets/new/image/not-found_new.png" width="200" />
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="stakeholders && (stakeholders.next_page_url || stakeholders.prev_page_url)" />

            <pagination
                v-if="stakeholders"
                :data="stakeholders"
                :get_data="get_data"
                :perpage="perpage"
            ></pagination>
            </div>


    </main-content>
</template>

<script>
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import mainContent from '@/components/main-content';
import { ApiService } from '@/common/api.service';
import Pagination from "@/components/main/pagination";
import PageTitle from "@/components/main/components/pageTitle";
import { merchantType, merchantTypeStr } from '@/constants/merchantType';
import { stakeholderStatus, stakeholderStatusStr, stakeholderVariant } from '@/constants/stakeholderStatus';
import { relatedMerchantType, relatedMerchantTypeStr, relatedMerchantTypeVariant } from '@/constants/related_merchant_type';
import { mapGetters } from 'vuex';

export default {
    components: {
        mainContent,
        PageTitle,
        Pagination,
    },
    computed: {
        ...mapGetters('gateway', [
            'form_data', 'status'
        ]),
        gateway_hashid() {
            return this.$route.query.gateway_hashid;
        },
        show_gateway_tabs() {
            return !!this.gateway_hashid && this.form_data && this.form_data.gateway_type === 0 && this.form_data.type === 2;
        },
        tab() {
            if (this.$route.name === 'stakeholders_get') {
                return 'stakeholders';
            }
            return this.$route.params.type || '';
        },
        show_enamad_tab() {
            return this.form_data && this.form_data.status === 12;
        },
        query() {
            let res = "";

            if (this.filter_full_name != "") {
                res = res + "&query[full_name]=" + this.filter_full_name;
            }

            if (this.filter_cellphone_number != "") {
                res = res + "&query[cellphone_number]=" + this.filter_cellphone_number;
            }

            if (this.filter_merchant_type != null) {
                res = res + "&query[merchant_type]=" + this.filter_merchant_type;
            }

            if (this.filter_status != null) {
                res = res + "&query[status]=" + this.filter_status;
            }

            if (this.filter_type != null) {
                res = res + "&query[type]=" + this.filter_type;
            }

            return res;
        },
    },
    data() {
        return {
            perpage: {
                value: 15,
            },

            filter_full_name: "",
            filter_cellphone_number: "",
            filter_merchant_type: null,
            filter_status: null,
            filter_type: null,

            stakeholders: null,
            merchant_type: merchantType,
            merchant_type_str: merchantTypeStr,
            stakeholder_status: stakeholderStatus,
            stakeholder_status_str: stakeholderStatusStr,
            stakeholder_variant: stakeholderVariant,
            relatedMerchantType: relatedMerchantType,
            relatedMerchantTypeStr: relatedMerchantTypeStr,
            relatedMerchantTypeVariant: relatedMerchantTypeVariant,
        };
    },
    mounted() {
        // Load gateway data if gateway_hashid is in query params
        if (this.gateway_hashid) {
            this.loadGatewayData();
        }
        
        ApiService.get("stakeholders", "").then(json => {
            this.stakeholders = json.data.data;
        });
        setTimeout(() => {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
        }, 1000);
    },
    watch: {
        '$route.query.gateway_hashid'(newHashid, oldHashid) {
            if (newHashid && newHashid !== oldHashid) {
                this.loadGatewayData();
            }
        }
    },
    methods: {
        loadGatewayData() {
            if (!this.gateway_hashid) {
                return;
            }
            this.$store.dispatch('gateway/find', this.gateway_hashid).catch(({ response }) => {
                // Silently fail if gateway data can't be loaded
                console.error('Failed to load gateway data:', response);
            });
        },
        resetQuery() {
            this.filter_full_name = "";
            this.filter_cellphone_number = "";
            this.filter_merchant_type = null;
            this.filter_status = null;
            this.filter_type = null;
        },
        get_data(url, callback = () => {}) {
            ApiService.query(url + this.query + "&perpage=" + this.perpage.value).then(json => {
                this.stakeholders = json.data.data;
                callback();
            });
        },
        reset_and_get() {
            this.resetQuery();
            this.get_data(this.stakeholders.path + "?page=1");
        },
        getUpdateLink(type, id) {
            if (type == relatedMerchantType.GATEWAY) {
                return '/stakeholders/update/' + id;
            }

            if (type == relatedMerchantType.WALLET) {
                return '/stakeholders/update-wallet-type/' + id;
            }

            if (type == relatedMerchantType.PSP) {
                return '/stakeholders/update-psp-type/' + id;
            }

            return '#';
        }
    },
}
</script>

<style scoped>
li{
    list-style: none;
}
</style>
